/* eslint-disable max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { AgroAvatar } from '../../atoms/AgroAvatar';
import { Text } from '../../atoms/Text';
import { IavatarUser2 } from '../../atoms/AgroIcon/icons';
var MobileUserData = withCssProps(function (_ref) {
  var level = _ref.level;
  var _useContext = useContext(AgroHeaderContext),
    user = _useContext.user,
    baseUrl = _useContext.baseUrl,
    translations = _useContext.translations;
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  return user && user.isLogged ? /*#__PURE__*/React.createElement(UserDataContainer, null, /*#__PURE__*/React.createElement(UserData, {
    level: level
  }, user.agroshop && user.agroshop.url ? /*#__PURE__*/React.createElement(AgroShopUser, null, /*#__PURE__*/React.createElement(StyledAgroAvatar, {
    href: "".concat(baseUrl).concat(user.agroshop.url),
    alt: user.agroshop.name,
    src: user.agroshop.logo
  }), /*#__PURE__*/React.createElement(Text, {
    type: "subtitle-md",
    color: "gray9",
    ml: "xs"
  }, user.fullName)) : /*#__PURE__*/React.createElement(DefaultUser, null, /*#__PURE__*/React.createElement(IavatarUser2, {
    width: "36px",
    height: "36px",
    fill: "black"
  }), /*#__PURE__*/React.createElement(Text, {
    type: "subtitle-md",
    color: "black",
    ml: "xs"
  }, showTranslation('hello'), " ", user.fullName)))) : null;
});
MobileUserData.propTypes = {
  items: PropTypes.array,
  isOpen: PropTypes.bool
};
export { MobileUserData };
var DefaultUser = styled.div.withConfig({
  displayName: "MobileUserData__DefaultUser",
  componentId: "tlvp30-0"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
var StyledAgroAvatar = styled(AgroAvatar).withConfig({
  displayName: "MobileUserData__StyledAgroAvatar",
  componentId: "tlvp30-1"
})(["background-color:white;width:54px;height:54px;border:1px solid ", ";svg{width:52px;height:52px;width:40px;height:40px;}path{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray200;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray600;
});
var AgroShopUser = styled.div.withConfig({
  displayName: "MobileUserData__AgroShopUser",
  componentId: "tlvp30-2"
})(["display:flex;align-items:center;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return css(["@media (max-width:", "){flex-direction:column;}"], theme.breakpoint.xxs);
});
var UserData = styled.div.withConfig({
  displayName: "MobileUserData__UserData",
  componentId: "tlvp30-3"
})(["background-color:", ";padding:16px;", " ", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray200;
}, function (_ref6) {
  var theme = _ref6.theme,
    level = _ref6.level;
  return level === 0 && css(["border-top:2px solid ", ";"], theme.colors.gray5);
}, function (_ref7) {
  var theme = _ref7.theme,
    level = _ref7.level;
  return level === 1 && css(["border-bottom:2px solid ", ";"], theme.colors.gray5);
});
var UserDataContainer = styled.div.withConfig({
  displayName: "MobileUserData__UserDataContainer",
  componentId: "tlvp30-4"
})([""]);